// src/components/inputs/DateRangePicker/utils.js

export const parseLocalDate = (date) => {
    if (!date) return null;

    if (date instanceof Date) {
        return new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
        );
    }

    if (typeof date === "string") {
        const parts = date.split("-");

        if (parts.length === 3) {
            const [year, month, day] = parts.map(Number);

            if (
                !Number.isNaN(year) &&
                !Number.isNaN(month) &&
                !Number.isNaN(day)
            ) {
                return new Date(year, month - 1, day);
            }
        }
    }

    const parsed = new Date(date);

    if (Number.isNaN(parsed.getTime())) return null;

    return new Date(
        parsed.getFullYear(),
        parsed.getMonth(),
        parsed.getDate()
    );
};

export const formatDateToYYYYMMDD = (date) => {
    if (!date) return "";

    const d = parseLocalDate(date);

    if (!d) return "";

    const year = d.getFullYear();

    const month = String(d.getMonth() + 1).padStart(2, "0");

    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const formatDate = (date, isArabic = false) => {
    if (!date) return "";

    const d = parseLocalDate(date);

    if (!d) return "";

    return d.toLocaleDateString(
        isArabic ? "ar-SA" : "en-US",
        {
            year: "numeric",
            month: "short",
            day: "numeric",
        }
    );
};

export const calculateDuration = (
    startDate,
    endDate
) => {
    if (!startDate || !endDate) {
        return {
            days: 0,
            nights: 0,
        };
    }

    const start = parseLocalDate(startDate);

    const end = parseLocalDate(endDate);

    if (!start || !end) {
        return {
            days: 0,
            nights: 0,
        };
    }

    const diff =
        Math.abs(
            end.getTime() - start.getTime()
        );

    const days =
        Math.ceil(
            diff /
            (1000 * 60 * 60 * 24)
        ) + 1;

    return {
        days,
        nights: Math.max(days - 1, 0),
    };
};

export const generateCalendarDays = (
    month
) => {
    const year = month.getFullYear();

    const monthIndex = month.getMonth();

    const firstDay = new Date(
        year,
        monthIndex,
        1
    );

    const lastDay = new Date(
        year,
        monthIndex + 1,
        0
    );

    const days = [];

    const offset = firstDay.getDay();

    for (let i = 0; i < offset; i++) {
        days.push(null);
    }

    for (
        let day = 1;
        day <= lastDay.getDate();
        day++
    ) {
        days.push(
            new Date(
                year,
                monthIndex,
                day
            )
        );
    }

    return days;
};

export const isToday = (date) => {
    if (!date) return false;

    const today = new Date();

    return (
        today.getFullYear() ===
        date.getFullYear() &&
        today.getMonth() ===
        date.getMonth() &&
        today.getDate() ===
        date.getDate()
    );
};

export const isBetween = (
    date,
    start,
    end
) => {
    if (!date || !start || !end)
        return false;

    const current =
        formatDateToYYYYMMDD(date);

    return (
        current >= start &&
        current <= end
    );
};

export const buildMonths = (
    currentMonth,
    monthsToShow
) => {
    return Array.from(
        {
            length: monthsToShow,
        },
        (_, index) =>
            new Date(
                currentMonth.getFullYear(),
                currentMonth.getMonth() +
                index,
                1
            )
    );
};

export const getWeekDays = (
    isArabic
) => {
    return isArabic
        ? [
            "ح",
            "ن",
            "ث",
            "ر",
            "خ",
            "ج",
            "س",
        ]
        : [
            "S",
            "M",
            "T",
            "W",
            "T",
            "F",
            "S",
        ];
};